import { render, staticRenderFns } from "./TheTransferChat.vue?vue&type=template&id=7b03d549&scoped=true"
import script from "./TheTransferChat.vue?vue&type=script&lang=js"
export * from "./TheTransferChat.vue?vue&type=script&lang=js"
import style0 from "./TheTransferChat.vue?vue&type=style&index=0&id=7b03d549&prod&lang=css"
import style1 from "./TheTransferChat.vue?vue&type=style&index=1&id=7b03d549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b03d549",
  null
  
)

export default component.exports